package uz.ferro.shop.model

import kotlinx.serialization.Serializable

@Serializable
data class MenuFilter(
    val id: Long?,
    val filter: Filter?,
    val filterValues: List<MenuFilterValue>?
)